import { Button } from './Button'

interface Props {
  title: string
  body: string
  actionLabel?: string
  onAction?: () => void
}

export function EmptyState({ title, body, actionLabel, onAction }: Props) {
  return (
    <div className="empty">
      <strong>{title}</strong>
      <p>{body}</p>
      {actionLabel && onAction ? (
        <div style={{ marginTop: 14 }}>
          <Button size="sm" variant="primary" onClick={onAction}>
            {actionLabel}
          </Button>
        </div>
      ) : null}
    </div>
  )
}
